import script from "./GlobalSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalSettings.vue?vue&type=script&setup=true&lang=js"

import "./GlobalSettings.vue?vue&type=style&index=0&id=73d59be3&lang=css"

const __exports__ = script;

export default __exports__